import React from 'react';
import { Inventory, InventoryItem, Variation, VariationItem } from '../../../@types/inventory';
import PlusIcon from '../../../assets/icons/PlusIcon';
import { InventoryLine } from './InventoryLine';
import { isLoading } from '../../core/InfoCard/InfoCard.stories';
import { Button } from '../../common';

interface InventoryFormProps {
  inventory: InventoryItem;
  setInventories: (inventories: InventoryItem) => void;
  setIsSideBarOpen: (id: boolean) => void;
  handleCreateInventory?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading: boolean;
  variations: VariationItem[];
  setVariations: (Variations: VariationItem[]) => void;
  error: any;
  errorMessage: string;
  variationList: any;
}

const InventoryForm: React.FC<InventoryFormProps> = ({
  inventory,
  setInventories,
  setIsSideBarOpen,
  handleCreateInventory,
  variations,
  setVariations,
  isLoading,
  error,
  errorMessage,
  variationList,
}) => {
  console.log(isLoading)
  return (
    <div>
      <InventoryLine
        inventory={inventory}
        setInventories={setInventories}
        variations={variations}
        setVariations={setVariations}
        error={error}
        variationList={variationList}
      />

      <div className="flex items-center gap-4 mt-8">
        <div className="w-1/2 md:hidden">
          <button
            onClick={() => setIsSideBarOpen(true)}
            className=" xl:w-[1040px] h-[40px] text-[14px] text-[#044E97] px-[27px] py-[14px] font-semibold rounded-md w-full bg-white  border border-[#044E97] inline-flex items-center justify-center whitespace-nowrap"
          >
            Input Variations
          </button>
        </div>
        <div className="w-1/2 md:w-full">
          {/* <button
            disabled={isLoading}
            onClick={handleCreateInventory}
            className="h-[40px] text-[14px] bg-[#044E97] px-[27px] py-[14px] font-semibold rounded-md w-full text-white inline-flex items-center justify-center whitespace-nowrap"
          >
            Add Inventory
          </button>
          {errorMessage && <span className="text-red-500 font-medium">{errorMessage}</span>} */}
          <Button variant="secondary" text="Add Inventory" onClick={handleCreateInventory} isLoading={isLoading} />
        </div>
      </div>
      <div className="mb-[44px]"></div>
    </div>
  );
};

export { InventoryForm };
